import { render, staticRenderFns } from "./OrganizationEdit.vue?vue&type=template&id=0239c2f8&scoped=true"
import script from "./OrganizationEdit.vue?vue&type=script&lang=js"
export * from "./OrganizationEdit.vue?vue&type=script&lang=js"
import style0 from "./OrganizationEdit.vue?vue&type=style&index=0&id=0239c2f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0239c2f8",
  null
  
)

export default component.exports